export default {
    queue_position: 'Posição na fila: {{position}}',
    chat_closed: 'Chat Encerrado',
    waiting_agent: 'Aguardando atendimento. Posição {{position}}',
    error_send_message: 'Houve um problema com o envio desta mensagem. Clique aqui para tentar novamente',
    message_action: {
        closed: 'O chat foi encerrado em {{date}} por {{name}}',
        queue_position: '<p class="m-0">Por favor, aguarde até que um agente atenda a sua solicitação.</p>' +
            'Você está na <b>posição {{position}}</b> da fila de atendimento.',
        agent_entered: '<b>{{name}}</b> entrou no chat',
        transferred_agent: 'Chat transferido para <b>{{name}}</b>',
        created_ticket: 'Chamado <b>{{number}}</b> foi aberto a partir deste chat',
    }
}
